<app-material>
    <div class="header" header>
        <h2>{{ 'lineSetter.pending-tool-requests.table.title' | translate }}</h2>
        <app-icon library="material" variant="filter_list" (click)="toggleFilters()"></app-icon>
    </div>
    <ng-container body>
        <app-pending-tool-requests-table [pendingToolRequests]="pendingToolRequests"
                                         [statusFilters]="filterStatusList"
                                         [tableConfig]="tableConfig"
                                         [isLoading]="isLoading"
                                         [showFilters]="showFilters"
                                         [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                         (sortChange)="onSortChange($event)"
                                         (filterChange)="onFilter($event)"
                                         (rowClick)="onTableRowClick($event)"
                                         (pageChange)="onPageChange($event)">
        </app-pending-tool-requests-table>
    </ng-container>
</app-material>
<app-pending-tool-requests-modal (closeToolRequest)="onClose($event)"
                                 [isConfirmationInProgress]="isConfirmationInProgress"
                                 label='lineSetter.pending-tool-requests.table.details-modal.title'>
</app-pending-tool-requests-modal>
<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage"
                        [confirmOnlyMode]="true"
                        [showConfirmButton]="false">
</app-confirmation-modal>
<app-logout-modal
    title="{{ 'lineSetter.pending-tool-requests.table.logoutModal.title' | translate }}"
    infoMessage="{{ 'lineSetter.pending-tool-requests.table.logoutModal.infoMessage' | translate }}"
    [timer]="badgeLogoutCountdownSeconds">
</app-logout-modal>

